import { FlipWords } from "@/components/ui/flip-words";
import { useSuggestedQueries } from "@brandclub/common-ui";
import { useTheme } from "@mui/material";
import { Sparkles } from "lucide-react";
import { AnimatedMasonryGrid } from "./AnimatedMasonryGrid";

interface ConciergeWelcomeProps {
  trendingSearches?: Array<{ text: string }>;
  onSearch: (searchTerm: string) => void;
  brandId?: number;
}

export function FlipWordsDemo() {
  const words = [
    "find the perfect gift for your mom",
    "save on your weekly grocery shopping",
    "find a Halloween costume for your dog",
  ];
  const theme = useTheme();

  return (
    <div
      className="tw:text-4xl tw:font-bold tw:text-left tw:max-w-[350px] tw:md:max-w-[500px] tw:h-[200px] tw:md:h-[200px] tw:pl-[18px] tw:md:pl-[43px]"
      style={{
        color: theme.palette.text.primary,
      }}
    >
      Use Concierge to <FlipWords words={words} duration={4_000} />
    </div>
  );
}

const ConciergeWelcome = ({
  trendingSearches,
  onSearch,
  brandId,
}: ConciergeWelcomeProps) => {
  const { data, isLoading: isLoadingSuggestedQueries } =
    useSuggestedQueries(brandId);

  const theme = useTheme();

  const displayQueries =
    data?.suggestedQuestions ||
    trendingSearches?.map((search) => search.text) ||
    [];

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        padding: "40px 20px",
        textAlign: "center",
        width: "100%",
        height: "100%",
        boxSizing: "border-box",
        overflow: "hidden",
      }}
    >
      {/* Heading with better typography */}
      <FlipWordsDemo />

      {/* Masonry Grid Section */}
      {displayQueries.length > 0 && !isLoadingSuggestedQueries && (
        <div style={{ width: "100%", maxWidth: "1200px" }}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "8px",
              marginBottom: "28px",
            }}
          >
            <Sparkles
              style={{
                width: "18px",
                height: "18px",
                color: theme.palette.text.secondary,
              }}
            />
            <h3
              style={{
                fontSize: "15px",
                fontWeight: "600",
                color: theme.palette.text.secondary,
                margin: 0,
                textTransform: "uppercase",
                letterSpacing: "0.05em",
              }}
            >
              For you
            </h3>
          </div>
          <AnimatedMasonryGrid items={displayQueries} onItemClick={onSearch} />
        </div>
      )}
    </div>
  );
};

export default ConciergeWelcome;
